export interface ColorPreset {
  label: string;
  color: string;
}

export const COLOR_PRESETS: ColorPreset[] = [
  { label: "Buttondown blue", color: "#0069ff" },
  { label: "Red", color: "#ef4444" },
  { label: "Orange", color: "#f97316" },
  { label: "Amber", color: "#f59e0b" },
  { label: "Yellow", color: "#eab308" },
  { label: "Lime", color: "#84cc16" },
  { label: "Green", color: "#22c55e" },
  { label: "Teal", color: "#14b8a6" },
  { label: "Blue", color: "#3b82f6" },
  { label: "Indigo", color: "#6366f1" },
  { label: "Violet", color: "#8b5cf6" },
  { label: "Purple", color: "#a855f7" },
  { label: "Fuchsia", color: "#d946ef" },
  { label: "Pink", color: "#ec4899" },
  { label: "Slate", color: "#475569" },
  { label: "Gray", color: "#6b7280" },
];

export const BACKGROUND_COLOR_PRESETS: ColorPreset[] = [
  { label: "White", color: "#ffffff" },
  { label: "Snow", color: "#fafafa" },
  { label: "Warm white", color: "#fffdf7" },
  { label: "Cream", color: "#fff8f0" },
  { label: "Linen", color: "#faf5ef" },
  { label: "Rose", color: "#fff0f5" },
  { label: "Peach", color: "#fff7ed" },
  { label: "Lemon", color: "#fefce8" },
  { label: "Mint", color: "#f0fff4" },
  { label: "Sage", color: "#f0f5f0" },
  { label: "Ice", color: "#f0f8ff" },
  { label: "Lavender", color: "#f5f0ff" },
  { label: "Cool gray", color: "#f4f4f5" },
  { label: "Warm gray", color: "#f5f5f4" },
  { label: "Slate", color: "#f1f5f9" },
  { label: "Stone", color: "#f5f0eb" },
];
